module.exports = __webpack_public_path__ + "img/active_right.15fb3edb.png";